import {
  loginByUsername,
  logout,
  getMenu,
  getInfo,
  getStatus,
} from "@/api/user";
import { validCertify } from "@/api/myQualification/index";
import {
  getToken,
  setToken,
  removeToken,
  getId,
  setId,
  removeId,
} from "@/utils/auth";
import { resetRouter } from "@/router";
import { encryption } from "@/utils/index";
import router from "@/router";
import { MessageBox, Message, Alert } from "element-ui";
import { GtPushManager } from "@/utils/gtpush";
const getDefaultState = () => {
  return {
    token: getToken(),
    id: getId(),
    // access_token: '',
    name: "",
    avatar: "",
    user_info: {},
    permissions: ["*:*:*"],
    roles: [],
    merchantTabName: "", //商户报表商户详情切换栏目记录
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
  },
  SET_ID: (state, id) => {
    state.id = id;
    setId(id);
  },
  SET_INFO: (state, info) => {
    state.user_info = info;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_MTAB_NAME: (state, name) => {
    state.merchantTabName = name;
  },
};

const actions = {
  setMTabName({ commit }, name) {
    commit("SET_MTAB_NAME", name || "");
  },
  setTokenNew({ commit }, access_token) {
    return new Promise((resolve, reject) => {
      commit("SET_TOKEN", access_token);
      resolve();
    });
  },
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      const user = encryption({
        data: userInfo,
        key: "8vkv0#e^D@mjv%VS",
        param: ["password"],
      });
      // console.log(user)
      loginByUsername(user.username, user.password, user.code, user.randomStr)
        .then((data) => {
          const { access_token, user_info } = data;
          new GtPushManager().init(); // 初始化推送
          commit("SET_TOKEN", access_token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMenus({ commit }, obj) {
    return new Promise((resolve, reject) => {
      const { id, type } = obj;
      getMenu(id)
        .then((res) => {
          console.log(res);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getStatus({ commit }, obj) {
    return new Promise((resolve, reject) => {
      validCertify().then((res) => {
        console.log(res, "res");
        if (res.code == 20007 || res.code == 20011 || res.code == 20010) {
          Message.info(res.msg);
          router.push({ path: "/mymerchantsettlementb" });
          reject(null);
          return;
        } else {
          if (res.code != 0) {
            // Message.info(res.msg)
            MessageBox.confirm(res.msg, {
              confirmButtonText: "确定",
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: "warning",
            });
          }
          getStatus()
            .then((res) => {
              const { code, data, msg } = res;
              const { status } = data;
              if (code == 0) {
                if (status == null) {
                  router.push({ path: "/mymerchantsettlementb" });
                  return;
                }
                if (status == 0) {
                  router.push({ path: "/qualificationDetails" });
                  return;
                }
                if (status == 1) {
                  router.push({ path: "/qualificationDetails" });
                  return;
                }
                if (status == 2) {
                  resolve();
                  router.push({ path: "/" });
                  return;
                }
              }
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.id)
        .then((res) => {
          if (res.code == 0) {
            const { permissions, roles, sysUser } = res.data;
            commit("SET_ROLES", roles.length == 0 ? ["a"] : roles);
            commit("SET_NAME", sysUser.fullName);
            let newPro = {};
            for (let i = 0; i < permissions.length; i++) {
              newPro[permissions[i]] = true;
            }
            commit("SET_PERMISSIONS", newPro);
            commit("SET_INFO", sysUser);
            resolve();
          } else {
            commit("SET_TOKEN", "");
            router.push({ path: "/" });
            Message.error(res.msg);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      new GtPushManager().offline(); // 离线推送
      removeToken(); // must remove  token  first
      removeId();
      resetRouter();
      commit("RESET_STATE");
      resolve();
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      removeId();
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
